import React from 'react';
import ChatWithUs from '../ChatWithUs/ChatWithUs';
import Form from '../Form/Form';
import { useLanguage } from '../../Contexts/LanguageContext';
import './HelpSection.scss';

const HelpSection = () => {
  const { getLanguageData } = useLanguage();
const data = getLanguageData();

  const sectionTitle = data.helpSection.heading;

  return (
    <>
      <div className="section-spacing help-section">
        <div className='help-card'>
          <h2>{sectionTitle}</h2>
          <div className="row-container">           
            <ChatWithUs />
            <Form />
          </div>
        </div>          
      </div>
    </>
  );
};

export default HelpSection;
